<template>
    <template v-if="filter.options.length > 0">
        <div>
            <div class="flex items-center justify-between">
                <h3 class="text-sm font-bold text-gray-800">{{ filter.label }}</h3>
            </div>

            <ul class="mt-2 space-y-2">
                <!-- MULTISELECT -->
                <template v-if="filter.type === 'multiselect'">
                    <li v-for="option in visibleOptions" :key="option.value">
                        <Checkbox v-model="modelValue" :value="option.value">
                            {{ option.label }}
                        </Checkbox>
                    </li>
                </template>

                <!-- SELECT -->
                <template v-if="filter.type === 'select'">
                    <RadioButtonGroup v-model="modelValue">
                        <li v-for="option in visibleOptions" :key="option.value">
                            <RadioButton :value="option.value">
                                {{ option.label }}
                            </RadioButton>
                        </li>
                    </RadioButtonGroup>
                </template>

                <!-- SHOW MORE / LESS -->
                <li v-if="hasMoreOptions">
                    <button type="button" class="text-sm text-primary hover:underline" @click="toggleShowAll">
                        {{ showAll ? $t('Show less') : $t('Show more') }}
                    </button>
                </li>
            </ul>
        </div>
    </template>
</template>

<script setup>
const props = defineProps({
    filter: {
        type: Object,
        required: true
    }
})

const modelValue = defineModel('modelValue', {
    type: Array,
    default: () => []
})

const showAll = ref(false)

const DEFAULT_LIMIT = 10

const visibleOptions = computed(() => {
    if (showAll.value) return props.filter.options
    return props.filter.options.slice(0, DEFAULT_LIMIT)
})

const hasMoreOptions = computed(() => {
    return props.filter.options.length > DEFAULT_LIMIT
})

const toggleShowAll = () => {
    showAll.value = !showAll.value
}
</script>
